export default function genererCritereRechercheFacture() {
  const currentYear = new Date().getFullYear();
  const firstDayOfYear = new Date(currentYear, 0, 1);
  const lastDayOfYear = new Date(currentYear, 11, 31);

  return {
    dates: {
      dateDebut: firstDayOfYear,
      dateFin: lastDayOfYear,
    },
    codeFacture: null,
    montant: null,
    etat: null,
  };
}
